import React from "react"
import { useTranslation } from "react-i18next"

import { thousandSeparator } from "utils"
import classes from "./CheckoutSummary.module.scss"

const CheckoutSummary = props => {
  const {
    total,
    subtotal,
    taxesAndCharges,
    totalFoodDiscounts,
    totalDeliveryDiscountByCoupon,
    totalDeliveryFeeBeforeDiscount
  } = props

  const [t] = useTranslation()

  return (
    <div className={classes["container"]}>
      {
        totalFoodDiscounts > 0 &&
        <div className={classes["totalItem"]}>
          <div className={classes["title"]}>
            {t("تخفیف_کالا")}
          </div>
          <div className={classes["number"]}>
            {thousandSeparator(-totalFoodDiscounts)}
          </div>
        </div>
      }

      {
        totalDeliveryDiscountByCoupon > 0 &&
        <div className={classes["totalItem"]}>
          <div className={classes["title"]}>
            {t("تخفیف_ارسال")}
          </div>
          <div className={classes["number"]}>
            {thousandSeparator(-totalDeliveryDiscountByCoupon)}
          </div>
        </div>
      }

      <div className={classes["totalItem"]}>
        <div>{t("مجموع_اقلام")}</div>
        <div className={classes["number"]}>
          {thousandSeparator(subtotal)}
        </div>
      </div>

      {
        totalDeliveryFeeBeforeDiscount !== 0 &&
        <div className={classes["totalItem"]}>
          <div>{t("هزینه_ی_ارسال")}</div>
          <div className={classes["number"]}>
            {thousandSeparator(totalDeliveryFeeBeforeDiscount)}
          </div>
        </div>
      }

      {taxesAndCharges.map(tax =>
        <div
          key={tax.title}
          className={classes["totalItem"]}
        >
          <div className={classes["title"]}>
            {tax.title}{" "}
            {tax.isPercentageModel ? `(${tax.percentage}%)` : ""}
          </div>
          <div className={classes["number"]}>
            {thousandSeparator(tax.amount)}
          </div>
        </div>
      )}

      <div className={classes["totalContainer"]}>
        <div className={classes["totalText"]}>
          {t("جمع_نهایی")}
        </div>
        <div className={classes["total"]}>
          {thousandSeparator(total)}
        </div>
      </div>
    </div>
  )
}

export default React.memo(CheckoutSummary)